import { useEffect, useRef, useState } from "react";

/**
 * Anima la entrada de un bloque cuando aparece en pantalla.
 * Respeta prefers-reduced-motion: si el usuario lo pide, el contenido
 * se muestra de una vez sin animación.
 */
export default function useReveal(options = {}) {
  const { threshold = 0.16, rootMargin = "0px 0px -8% 0px", once = true } =
    options;
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    const prefersReduced =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (prefersReduced || typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            if (once) observer.unobserve(entry.target);
          } else if (!once) {
            setVisible(false);
          }
        });
      },
      { threshold, rootMargin }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [threshold, rootMargin, once]);

  return [ref, visible];
}
